import { fetchApiData } from "../../utils/apiUtils";
import { ENDPOINT } from "../../constants/api";
import * as entitySlice from "../slices/entity.slice";
export const getAllEntityStructure = () => async (dispatch) => {
  const data = await fetchApiData({
    method: "get",
    endpoint: `${ENDPOINT.BLANK}/entity-structure/list`,
    dispatch,
  });
  if (data) {
    dispatch(entitySlice.setEntity(data));
    return data;
  }
};
